module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mb4 bg-white shadow-theme br-all br20 pv3 flex-1"
  }, [_c('div', {
    staticClass: "container pointer flex flex-column w-100-mobile br3 pa3 mh3-l h-100"
  }, [_c('div', {
    staticClass: "flex flex-row justify-between items-center plan-title"
  }, [_c('div', {
    staticClass: "flex flex-row items-center flex-grow-1 w-100-mobile"
  }, [_c('home-plus-icon', {
    attrs: {
      "alt": "Home Plus Plan",
      "height": "60",
      "width": "60"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "flex flex-column flex-grow-1 mr1",
    staticStyle: {
      "margin-left": "0.75rem"
    }
  }, [_c('h5', {
    staticClass: "ma0 cera-med",
    staticStyle: {
      "font-size": "1.1rem"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n          ")]), _vm._v(" "), _c('h6', {
    staticClass: "m-0 cera-med grey",
    staticStyle: {
      "font-size": "0.85rem"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.subtitle) + "\n          ")])])], 1)]), _vm._v(" "), _c('upgrade-plan-info', {
    attrs: {
      "includeOpen": _vm.includeOpen,
      "toggleInclude": _vm.toggleInclude,
      "planData": _vm.planData,
      "description": _vm.description,
      "planCostDifference": _vm.planCostDifference,
      "planDeductibleRange": _vm.planDeductibleRange
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-057d7647","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upgrade-plan/UpgradePlanCard.vue
// module id = 1307
// module chunks = 0